module.exports = __webpack_public_path__ + "img/库存管理.75ce2f39.svg";